import { useQuery } from '@tanstack/react-query';
import { Endpoint } from '@/Config/api/endpoint';
import { ConversationAnalysisAlertsApi } from '@/Domain/api/Conversation/ConversationAnalysisAlerts.api';

export const useConversationAnalysisAlertsList = () =>
  useQuery({
    queryKey: [`${Endpoint.conversationAnalysisAlerts.list}-list`],
    queryFn: () => ConversationAnalysisAlertsApi.list(),
  });
